<div class="row step-header">
  <div class="col col-100">
    <h3>Beat the rush by preordering now</h3>
    <p class="subhead">
      Demand for Starry has been high, so we’ve opened up more spots on our
      preorder list. Enter your info below to get a once-in-a-lifetime
      launch offer.
    </p>
    <p class="step-error js-paymentError">
      <!-- Stripe Errors will be appended here -->
    </p>
  </div>
</div>
<div class="card-layout no-border text-dark">
  <div class="col col-100 card-lid">
    <h4>Preorder now to get:</h4>
    <div class="offer-bullets">
      <div class="offer-bullet">
        <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 25 25" xml:space="preserve">
          <style type="text/css">.st0{fill:#71E8DC;}</style>
          <g id="Columbus-Prorder-Flow">
            <g transform="translate(-67.000000, -376.000000)">
              <g transform="translate(67.000000, 368.000000)">
                <g>
                  <g transform="translate(0.000000, 8.000000)">
                    <path id="Shape" class="st0" d="M12.5,0C5.6,0,0,5.6,0,12.5S5.6,25,12.5,25S25,19.4,25,12.5S19.4,0,12.5,0z M10.8,19.7
                      l-5.9-5.9l2.7-2.7l3.3,3.3l7.6-7.6l2.7,2.7L10.8,19.7z"
                    />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </svg>
        <h5>3 Months Free</h5>
        <span>On our $50/mo Starry Plus plan</span>
      </div>
      <div class="offer-bullet">
        <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 25 25" xml:space="preserve">
          <style type="text/css">.st0{fill:#71E8DC;}</style>
          <g id="Columbus-Prorder-Flow">
            <g transform="translate(-67.000000, -376.000000)">
              <g transform="translate(67.000000, 368.000000)">
                <g>
                  <g transform="translate(0.000000, 8.000000)">
                    <path id="Shape" class="st0" d="M12.5,0C5.6,0,0,5.6,0,12.5S5.6,25,12.5,25S25,19.4,25,12.5S19.4,0,12.5,0z M10.8,19.7
                      l-5.9-5.9l2.7-2.7l3.3,3.3l7.6-7.6l2.7,2.7L10.8,19.7z"
                    />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </svg>
        <h5>Priority Installation</h5>
        <span>As soon as service is available</span>
      </div>
      <div class="offer-bullet">
        <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 25 25" xml:space="preserve">
          <style type="text/css">.st0{fill:#71E8DC;}</style>
          <g id="Columbus-Prorder-Flow">
            <g transform="translate(-67.000000, -376.000000)">
              <g transform="translate(67.000000, 368.000000)">
                <g>
                  <g transform="translate(0.000000, 8.000000)">
                    <path id="Shape" class="st0" d="M12.5,0C5.6,0,0,5.6,0,12.5S5.6,25,12.5,25S25,19.4,25,12.5S19.4,0,12.5,0z M10.8,19.7
                      l-5.9-5.9l2.7-2.7l3.3,3.3l7.6-7.6l2.7,2.7L10.8,19.7z"
                    />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </svg>
        <h5>Mystery Launch Reward</h5>
        <span>Fun mystery, not spooky</span>
      </div>
    </div>
  </div>
  <div class="card-inner">
    <div class="row">
      <div class="col col-100 desktop--col-50">
        <label for="first_name">First name*</label>
        <input class="first_name" id="first_name" name="first_name" placeholder="Johnny" type="text"/>
      </div>
      <div class="col col-100 desktop--col-50">
        <label for="last_name">Last name*</label>
        <input class="last_name" id="last_name" name="last_name" placeholder="Appleseed" type="text"/>
      </div>
    </div>
    <div class="row">
      <div class="col col-100 desktop--col-80">
        <label>Building address*</label>
        <div class="building-address">
          <span>{{ gis_address }}</span>
          <a href="/">Edit Address</a>
        </div>
      </div>
      <div class="col col-100 desktop--col-20">
        <label for="unit">Unit #</label>
        <input class="unit" id="unit" name="unit" placeholder="123" type="text"/>
      </div>
    </div>
    <div class="row">
      <div class="col col-100 pb0">
        <div id="payment-request-button" class="hide-on-payment-api-success"></div>
        <div id="payment-request-text" class="hide-on-payment-api-success">
          <span>Or enter card details</span>
        </div>
        <div id="payment-request-success" class="show-on-payment-api-success">
          <div class="icon">
            <svg width="84px" height="84px" viewBox="0 0 84 84" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
              <circle class="border" cx="42" cy="42" r="40" stroke-linecap="round" stroke-width="4" stroke="#000" fill="none"></circle>
              <path class="checkmark" stroke-linecap="round" stroke-linejoin="round" d="M23.375 42.5488281 36.8840688 56.0578969 64.891932 28.0500338" stroke-width="4" stroke="#000" fill="none"></path>
            </svg>
          </div>
          <span class="message">Your payment information has been saved</span>
        </div>
      </div>
      <div class="col col-100 hide-on-payment-api-success">
        <label for="cc_number_element">Card Number*</label>
        <div class="cc_input" id="cc_number_element"></div>
        <div class="error-message"></div>
      </div>
    </div>

    <div class="row">
      <div class="col col-100 desktop--col-50 hide-on-payment-api-success">
        <label for="cc_expiry_element">Expiration Date*</label>
        <div class="cc_input" id="cc_expiry_element"></div>
        <div class="error-message"></div>
      </div>
      <div class="col col-100 desktop--col-50 hide-on-payment-api-success">
        <label for="cc_cvc_element">CVC*</label>
        <div class="cc_input" id="cc_cvc_element"></div>
        <div class="error-message"></div>
      </div>
    </div>

    <div class="row">
      <div class="col col-100">
        <p class="due-today">$0 due today</p>
        <p class="charge-disclaimer">
          You will not be charged until installation. We’ll invite you to
          choose an appointment time once we’ve reached your area.
        </p>
      </div>
    </div>
  </div>
</div>
